import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface ICariHesap_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ICariHesap_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GetAktifSirket: any[];
  GetAktifSirket_dummy: any[];
  AyinIlkGunu: any[];
  AyinIlkGunu_dummy: any[];
  GununTarihi: any[];
  GununTarihi_dummy: any[];
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetCariBankaBilgileri: any[];
  GetCariBankaBilgileri_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetCariParaBirimi: any[];
  GetCariParaBirimi_dummy: any[];
  GetCariEkstre: any[];
  GetCariEkstre_dummy: any[];
  CariEkstreToplam: any[];
  CariEkstreToplam_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  isComp797609Visible: "visible" | "hidden";
  isComp660102Visible: "visible" | "hidden";
  isComp926419Visible: "visible" | "hidden";
  isComp46342Visible: "visible" | "hidden";
  isComp279339Visible: "visible" | "hidden";
  isComp309408Visible: "visible" | "hidden";
  isComp216359Visible: "visible" | "hidden";
}

export class CariHesap_ScreenBase extends React.PureComponent<
  ICariHesap_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  carihesap_712101_value_kuikaDateRef: React.RefObject<any>;
  carihesap_585508_value_kuikaDateRef: React.RefObject<any>;
  carihesap_168896_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 616814,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 168896,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORDS FOUNDED",
          TagName: "Table2_nodatafoundmessage",
        },
        {
          Id: 361026,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 737096,
          PropertyName: "value",
          Value: "DEPT TOTAL",
          TagName: "Label5_value",
        },
        {
          Id: 688728,
          PropertyName: "value",
          Value: "TOTAL RECEIVABLES",
          TagName: "Label5_0_value",
        },
        {
          Id: 543817,
          PropertyName: "value",
          Value: "BALANCE",
          TagName: "Label9_0_value",
        },
        {
          Id: 94372,
          PropertyName: "title",
          Value: "DATE",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 620702,
          PropertyName: "title",
          Value: "ACTION TYPE",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 700907,
          PropertyName: "title",
          Value: "DOCUMENT NO",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 128921,
          PropertyName: "title",
          Value: "EXPLANATION",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 349619,
          PropertyName: "title",
          Value: "PAYMENT DUE",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 465695,
          PropertyName: "title",
          Value: "DEPT",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 805622,
          PropertyName: "title",
          Value: "RECEIVABLES",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 239746,
          PropertyName: "title",
          Value: "BALANCE",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 210402,
          PropertyName: "title",
          Value: "CURRENCY TYPE",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 823721,
          PropertyName: "value",
          Value: "USER ACCOUNT",
          TagName: "Label23_value",
        },
        {
          Id: 655022,
          PropertyName: "value",
          Value: "USER ACCOUNT ACTION LISTED",
          TagName: "Label24_value",
        },
        {
          Id: 712101,
          PropertyName: "placeholder",
          Value: "START DATE",
          TagName: "Date3_placeholder",
        },
        {
          Id: 585508,
          PropertyName: "placeholder",
          Value: "END DATE",
          TagName: "Date2_placeholder",
        },
        {
          Id: 504299,
          PropertyName: "label",
          Value: "LIST ALL",
          TagName: "Button1_label",
        },
        {
          Id: 612540,
          PropertyName: "label",
          Value: "EXPORT TO EXCEL",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 616814,
          PropertyName: "placeholder",
          Value: "Vaden no, OEM no, nom du produit, marque, modèle, véhicule",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 168896,
          PropertyName: "nodatafoundmessage",
          Value: "Aucun résultat",
          TagName: "Table2_nodatafoundmessage",
        },
        {
          Id: 361026,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 737096,
          PropertyName: "value",
          Value: "Total dettes",
          TagName: "Label5_value",
        },
        {
          Id: 688728,
          PropertyName: "value",
          Value: "Total créances",
          TagName: "Label5_0_value",
        },
        {
          Id: 543817,
          PropertyName: "value",
          Value: "Solde",
          TagName: "Label9_0_value",
        },
        {
          Id: 94372,
          PropertyName: "title",
          Value: "Date",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 620702,
          PropertyName: "title",
          Value: "Type de transaction",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 700907,
          PropertyName: "title",
          Value: "N° Document",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 128921,
          PropertyName: "title",
          Value: "Description",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 349619,
          PropertyName: "title",
          Value: "Échéance",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 465695,
          PropertyName: "title",
          Value: "Débit",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 805622,
          PropertyName: "title",
          Value: "Crédit",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 239746,
          PropertyName: "title",
          Value: "Solde",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 210402,
          PropertyName: "title",
          Value: "Devise",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 823721,
          PropertyName: "value",
          Value: "Compte client",
          TagName: "Label23_value",
        },
        {
          Id: 655022,
          PropertyName: "value",
          Value: "Historique des transaction du compte client",
          TagName: "Label24_value",
        },
        {
          Id: 712101,
          PropertyName: "placeholder",
          Value: "Date de début",
          TagName: "Date3_placeholder",
        },
        {
          Id: 585508,
          PropertyName: "placeholder",
          Value: "Date de fin",
          TagName: "Date2_placeholder",
        },
        {
          Id: 504299,
          PropertyName: "label",
          Value: "Afficher",
          TagName: "Button1_label",
        },
        {
          Id: 612540,
          PropertyName: "label",
          Value: "Exporter vers Excel",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 616814,
          PropertyName: "placeholder",
          Value:
            "No.Vaden, No. oem, nombre del producto, marca, modelo, vehículo",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 168896,
          PropertyName: "nodatafoundmessage",
          Value: "No se encontraron registros para agregar",
          TagName: "Table2_nodatafoundmessage",
        },
        {
          Id: 361026,
          PropertyName: "label",
          Value: "Perfil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 737096,
          PropertyName: "value",
          Value: "Total de débito",
          TagName: "Label5_value",
        },
        {
          Id: 688728,
          PropertyName: "value",
          Value: "Total de crédito",
          TagName: "Label5_0_value",
        },
        {
          Id: 543817,
          PropertyName: "value",
          Value: "Saldo",
          TagName: "Label9_0_value",
        },
        {
          Id: 94372,
          PropertyName: "title",
          Value: "Fecha",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 620702,
          PropertyName: "title",
          Value: "Tipo de transacción",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 700907,
          PropertyName: "title",
          Value: "Número de documento",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 128921,
          PropertyName: "title",
          Value: "Descripción",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 349619,
          PropertyName: "title",
          Value: "Fecha de vencimiento",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 465695,
          PropertyName: "title",
          Value: "Débito",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 805622,
          PropertyName: "title",
          Value: "Crédito",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 239746,
          PropertyName: "title",
          Value: "Saldo",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 210402,
          PropertyName: "title",
          Value: "Tipo de moneda",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 823721,
          PropertyName: "value",
          Value: "Cuenta corriente",
          TagName: "Label23_value",
        },
        {
          Id: 655022,
          PropertyName: "value",
          Value: "Se listan las transacciones de su cuenta corriente.",
          TagName: "Label24_value",
        },
        {
          Id: 712101,
          PropertyName: "placeholder",
          Value: "Fecha de inicio",
          TagName: "Date3_placeholder",
        },
        {
          Id: 585508,
          PropertyName: "placeholder",
          Value: "Fecha de finalización",
          TagName: "Date2_placeholder",
        },
        {
          Id: 504299,
          PropertyName: "label",
          Value: "Lista",
          TagName: "Button1_label",
        },
        {
          Id: 612540,
          PropertyName: "label",
          Value: "Exportar a Excel",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "e8140a36-2f1e-42d5-85a4-7643d9330a15",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 616814,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 740700, PropertyName: "label", Value: "Turkish" },
        { Id: 708047, PropertyName: "label", Value: "English" },
        { Id: 936860, PropertyName: "label", Value: "Spanish" },
        { Id: 540461, PropertyName: "label", Value: "French" },
        { Id: 361026, PropertyName: "label", Value: "Profil" },
        { Id: 737096, PropertyName: "value", Value: "Borç Toplamı" },
        { Id: 926419, PropertyName: "value", Value: "₺" },
        { Id: 688728, PropertyName: "value", Value: "Alacak Toplamı" },
        { Id: 279339, PropertyName: "value", Value: "₺" },
        { Id: 543817, PropertyName: "value", Value: "Bakiye" },
        { Id: 216359, PropertyName: "value", Value: "₺" },
        { Id: 625845, PropertyName: "value", Value: "Banka Adı:" },
        { Id: 109434, PropertyName: "value", Value: "Banka Hesap No:" },
        { Id: 246304, PropertyName: "value", Value: "Banka Şube:" },
        { Id: 189882, PropertyName: "value", Value: "Banka Iban:" },
        { Id: 138174, PropertyName: "value", Value: "SwiftCode:" },
        { Id: 823721, PropertyName: "value", Value: "Cari Hesap" },
        {
          Id: 655022,
          PropertyName: "value",
          Value: "Cari Hesap Hareketleriniz Listelenmektedir.",
        },
        { Id: 712101, PropertyName: "placeholder", Value: "Başlangıç Tarihi" },
        { Id: 585508, PropertyName: "placeholder", Value: "Bitiş Tarihi" },
        { Id: 504299, PropertyName: "label", Value: "Listele" },
        { Id: 612540, PropertyName: "label", Value: "Excele Aktar" },
        {
          Id: 168896,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 94372, PropertyName: "title", Value: "Tarih" },
        { Id: 68100, PropertyName: "value", Value: "[datafield:tarih]" },
        { Id: 620702, PropertyName: "title", Value: "Hareket Türü" },
        {
          Id: 705558,
          PropertyName: "value",
          Value: "[datafield:hareket_turu]",
        },
        { Id: 700907, PropertyName: "title", Value: "Belge No" },
        { Id: 166336, PropertyName: "value", Value: "[datafield:belge_no]" },
        { Id: 128921, PropertyName: "title", Value: "Açıklama" },
        { Id: 335678, PropertyName: "value", Value: "[datafield:aciklama]" },
        { Id: 349619, PropertyName: "title", Value: "Vade Tarihi" },
        { Id: 337302, PropertyName: "value", Value: "[datafield:vade_tarihi]" },
        { Id: 465695, PropertyName: "title", Value: "Borç" },
        { Id: 203488, PropertyName: "value", Value: "[datafield:borc]" },
        { Id: 805622, PropertyName: "title", Value: "Alacak" },
        { Id: 981069, PropertyName: "value", Value: "[datafield:alacak]" },
        { Id: 239746, PropertyName: "title", Value: "Bakiye" },
        { Id: 892054, PropertyName: "value", Value: "[datafield:bakiye]" },
        { Id: 210402, PropertyName: "title", Value: "Doviz Türü" },
        { Id: 843128, PropertyName: "value", Value: "[datafield:doviz_turu]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.carihesap_616814_value_kuikaTextInputRef = React.createRef();
    this.carihesap_712101_value_kuikaDateRef = React.createRef();
    this.carihesap_585508_value_kuikaDateRef = React.createRef();
    this.carihesap_168896_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetParametreler: [],
      GetAktifSirket: [],
      AyinIlkGunu: [],
      GununTarihi: [],
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetCariBankaBilgileri: [],
      GetToplamTeklifSepeti: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetCariParaBirimi: [],
      GetCariEkstre: [],
      CariEkstreToplam: [],
      ExportExcel: "",
      isComp797609Visible: "hidden",
      isComp660102Visible: "hidden",
      isComp926419Visible: "hidden",
      isComp46342Visible: "hidden",
      isComp279339Visible: "hidden",
      isComp309408Visible: "hidden",
      isComp216359Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("carihesap", "blank_screen");
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.CariHesapPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.CariHesapPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("carihesap", "blank_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("carihesap", "blank_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.CariHesapPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.CariHesapPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      carihesap_712101_value:
        this.state.AyinIlkGunu?.at?.(0)?.ayinIlkGunu ?? undefined,
      carihesap_585508_value:
        this.state.GununTarihi?.at?.(0)?.bugun ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  CariHesapPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CariHesap/CariHesapPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp797609Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetAktifSirket = result?.data.getAktifSirket;
    stateVars.AyinIlkGunu = result?.data.ayinIlkGunu;
    formVars.carihesap_712101_value = ReactSystemFunctions.value(
      this,
      stateVars.AyinIlkGunu !== undefined
        ? stateVars.AyinIlkGunu?.length > 0
          ? stateVars.AyinIlkGunu[0].ayinIlkGunu
          : null
        : this.state.AyinIlkGunu?.length > 0
        ? this.state.AyinIlkGunu[0].ayinIlkGunu
        : null
    );
    stateVars.GununTarihi = result?.data.gununTarihi;
    formVars.carihesap_585508_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );
    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.carihesap_626775_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.CariHesapPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CariHesapPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.CariHesapPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CariHesapPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      CARI_KOD_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      paraBirimi_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
      isYurtici_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "number"
      ),
      CariKod_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      BaslangicTarihi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "carihesap_712101_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "carihesap_585508_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      isYurtici_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "number"
      ),
      CariKod_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CariHesap/CariHesapPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.isComp660102Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp926419Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp46342Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp279339Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp309408Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp216359Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetCariBankaBilgileri = result?.data.getCariBankaBilgileri;
    formVars.carihesap_261604_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].banK_NAME
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].banK_NAME
        : null
    );
    formVars.carihesap_768056_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].banK_HESAPNO
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].banK_HESAPNO
        : null
    );
    formVars.carihesap_110497_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].banK_SUBE
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].banK_SUBE
        : null
    );
    formVars.carihesap_60004_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].banK_IBAN
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].banK_IBAN
        : null
    );
    formVars.carihesap_527437_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].swiftcode
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].swiftcode
        : null
    );
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.carihesap_375634_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.carihesap_158038_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetCariParaBirimi = result?.data.getCariParaBirimi;
    formVars.carihesap_660102_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.carihesap_46342_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.carihesap_309408_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    stateVars.GetCariEkstre = result?.data.getCariEkstre;

    stateVars.CariEkstreToplam = result?.data.cariEkstreToplam;
    formVars.carihesap_609305_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].borc
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].borc
        : null
    );
    formVars.carihesap_11526_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].alacak
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].alacak
        : null
    );
    formVars.carihesap_17670_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].bakiye
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].bakiye
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.CariHesapPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CariHesapPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.carihesap_375634_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    stateVars.isComp797609Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.carihesap_158038_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.carihesap_626775_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.carihesap_523010_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    formVars.carihesap_660102_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp660102Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp926419Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.carihesap_609305_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].borc
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].borc
        : null
    );

    formVars.carihesap_46342_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp46342Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp279339Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.carihesap_11526_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].alacak
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].alacak
        : null
    );

    formVars.carihesap_309408_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp309408Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp216359Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.carihesap_17670_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].bakiye
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].bakiye
        : null
    );

    formVars.carihesap_261604_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].banK_NAME
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].banK_NAME
        : null
    );

    formVars.carihesap_768056_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].banK_HESAPNO
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].banK_HESAPNO
        : null
    );

    formVars.carihesap_110497_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].banK_SUBE
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].banK_SUBE
        : null
    );

    formVars.carihesap_60004_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].banK_IBAN
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].banK_IBAN
        : null
    );

    formVars.carihesap_527437_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBankaBilgileri !== undefined
        ? stateVars.GetCariBankaBilgileri?.length > 0
          ? stateVars.GetCariBankaBilgileri[0].swiftcode
          : null
        : this.state.GetCariBankaBilgileri?.length > 0
        ? this.state.GetCariBankaBilgileri[0].swiftcode
        : null
    );

    formVars.carihesap_712101_value = ReactSystemFunctions.value(
      this,
      stateVars.AyinIlkGunu !== undefined
        ? stateVars.AyinIlkGunu?.length > 0
          ? stateVars.AyinIlkGunu[0].ayinIlkGunu
          : null
        : this.state.AyinIlkGunu?.length > 0
        ? this.state.AyinIlkGunu[0].ayinIlkGunu
        : null
    );

    formVars.carihesap_585508_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );

    stateVars.dataSource_168896 =
      stateVars.GetCariEkstre ?? this.state.GetCariEkstre;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  CariHesapComponent_616814_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "carihesap_616814_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "CariHesap",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CariHesapComponent_797609_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "CariHesap",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CariHesapComponent_716034_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "CariHesap",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "423996",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CariHesapComponent_740700_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CariHesapComponent_708047_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CariHesapComponent_936860_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CariHesapComponent_540461_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CariHesapComponent_361026_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "CariHesap",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CariHesapComponent_504299_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      isYurtici_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "number"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "carihesap_712101_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "carihesap_585508_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CariHesap/CariHesapComponent_504299_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariEkstre = result?.data.getCariEkstre;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.CariHesapComponent_504299_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CariHesapComponent_504299_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_168896 =
      stateVars.GetCariEkstre ?? this.state.GetCariEkstre;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CariHesapComponent_612540_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.GetCariEkstre),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CariHesap/CariHesapComponent_612540_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , 423996] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.CariHesapPageInit();
    }
  }
}
